import { Component, Input } from "@angular/core"
import { LearningObject } from "../../models/learningObject.model"
import { ColorCodeService } from "../../services/color-code.service"
import { UserService } from "../../services/user.service"

@Component({
    selector: "app-card",
    template: "",
})
export class CardComponent {
    @Input("show-subject") public showSubject: boolean = false
    @Input("show-as-collection") public showAsCollection: boolean = false
    @Input() public resource: LearningObject = null
    @Input() public gtmPrefix: string = ""
    public placeholderImg: string = null

    constructor(
        protected colorCodeService: ColorCodeService,
        public userService: UserService
    ) {
        this.placeholderImg = require("../../../assets/placeholder-image.svg")
    }

    public getSubjectColor() {
        return this.colorCodeService.getSubjectColor(this.resource.subject.id)
    }

    public getAbsoluteUrl() {
        return this.resource.canonicalUrl
    }

    public getSubjectClass() {
        return `card-subject gtm-${this.gtmPrefix}-subject`
    }

    public getResourceBodyClass() {
        return `gtm-${this.gtmPrefix}-resource-body`
    }
}
